// 9:16 story card for the Solano-Teller (plate check). Pure presentation.
const COLORS = { veg: "#7AA37F", protein: "#C97B5B", carbs: "#E8B25E", fats: "#8DB38B" };
const TEAL = "#1F5C5F";
const ORANGE = "#E8951C";
const CREAM = "#FAF4E6";
const INK = "#1A1D1E";

export default function PlateStoryCard({ plate, verdict, labels, assets, dateLabel }) {
  const slices = [
    { key: "veg", pct: plate.veg_pct, target: 50 },
    { key: "protein", pct: plate.protein_pct, target: 25 },
    { key: "carbs", pct: plate.carbs_pct, target: 25 },
  ];
  const R = 190, C = 2 * Math.PI * R;
  let acc = 0;
  const verdictColor = { excellent: COLORS.veg, good: "#5A8B8F", adjust: ORANGE }[verdict] || TEAL;
  return (
    <div id="social-share-card" style={{
      width: 1080, height: 1920, boxSizing: "border-box", overflow: "hidden", position: "relative",
      background: `linear-gradient(180deg, ${CREAM} 0%, #F3E9D2 100%)`, color: INK,
      fontFamily: "'Inter','Segoe UI',system-ui,-apple-system,sans-serif", display: "flex", flexDirection: "column", padding: "230px 72px 220px",
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ background: "#fff", borderRadius: 999, padding: "16px 28px", boxShadow: "0 4px 16px rgba(31,63,65,0.08)" }}>
          <img src={assets.logo} alt="" style={{ width: 230, display: "block", objectFit: "contain" }} />
        </div>
        <div style={{ background: TEAL, color: "#fff", borderRadius: 999, padding: "16px 30px", fontSize: 28, fontWeight: 700 }}>{dateLabel}</div>
      </div>

      <p style={{ marginTop: 44, fontSize: 28, fontWeight: 700, letterSpacing: "0.18em", textTransform: "uppercase", color: "#6B8688" }}>{labels.kicker}</p>
      <p style={{ marginTop: 10, fontSize: 66, fontWeight: 900, lineHeight: 1.02, color: TEAL, letterSpacing: "-0.02em" }}>{labels.title}</p>

      <div style={{ marginTop: 40, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ position: "relative", width: 440, height: 440 }}>
          <svg viewBox="0 0 520 520" width={440} height={440}>
            <circle cx="260" cy="260" r={R} fill="none" stroke="#fff" strokeWidth="64" />
            {slices.map((s) => {
              if (s.pct <= 0) return null;
              const len = (s.pct / 100) * C;
              const off = C - (acc / 100) * C;
              acc += s.pct;
              return <circle key={s.key} cx="260" cy="260" r={R} fill="none" stroke={COLORS[s.key]} strokeWidth="64"
                strokeDasharray={`${len} ${C - len}`} strokeDashoffset={off} transform="rotate(-90 260 260)" strokeLinecap="butt" />;
            })}
          </svg>
          <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center" }}>
            <div style={{ background: verdictColor, color: "#fff", borderRadius: 999, padding: "14px 30px", fontSize: 32, fontWeight: 800 }}>{labels.verdict}</div>
            <p style={{ marginTop: 18, fontSize: 26, fontWeight: 600, color: "#6B8688" }}>{labels.targetLine}</p>
          </div>
        </div>
      </div>

      <div style={{ marginTop: 40, display: "flex", gap: 20 }}>
        {slices.map((s) => (
          <div key={s.key} style={{ flex: 1, background: "#fff", borderRadius: 28, padding: "22px 14px", textAlign: "center", boxShadow: "0 4px 16px rgba(31,63,65,0.06)", borderTop: `10px solid ${COLORS[s.key]}` }}>
            <p style={{ fontSize: 56, fontWeight: 900, color: COLORS[s.key], margin: 0, lineHeight: 1 }}>{s.pct}%</p>
            <p style={{ fontSize: 28, fontWeight: 700, color: INK, margin: "12px 0 0" }}>{labels.slices[s.key]}</p>
            <p style={{ fontSize: 24, color: "#8FA9AB", margin: "6px 0 0" }}>{labels.target} {s.target}%</p>
          </div>
        ))}
      </div>

      {plate.healthy_fats && (
        <div style={{ marginTop: 24, background: plate.healthy_fats.present ? "rgba(122,163,127,0.16)" : "rgba(232,149,28,0.14)", borderRadius: 24, padding: "20px 28px", display: "flex", alignItems: "center", gap: 18 }}>
          <span style={{ fontSize: 40 }}>{plate.healthy_fats.present ? "✅" : "💧"}</span>
          <p style={{ fontSize: 30, fontWeight: 700, color: plate.healthy_fats.present ? "#3F6B45" : "#A65E00", margin: 0 }}>
            {labels.fats}: {plate.healthy_fats.present ? (plate.healthy_fats.items || []).slice(0, 3).join(", ") || "✓" : labels.fatsMissing}
          </p>
        </div>
      )}

      <div style={{ marginTop: "auto", background: TEAL, borderRadius: 36, padding: "32px 40px", display: "flex", alignItems: "center", gap: 32, color: "#fff" }}>
        <img src={assets.mascot} alt="" style={{ width: 130, height: 130, objectFit: "contain", flexShrink: 0 }} />
        <div style={{ minWidth: 0 }}>
          <p style={{ fontSize: 26, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "#B7D1D2", margin: 0 }}>{labels.tipKicker}</p>
          <p style={{ fontSize: 31, fontWeight: 600, lineHeight: 1.3, margin: "10px 0 0", display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden" }}>{labels.tip}</p>
        </div>
      </div>
      <p style={{ marginTop: 28, textAlign: "center", fontSize: 26, fontWeight: 700, color: "#6B8688" }}>{labels.madeWith} · solano-essence.com</p>
    </div>
  );
}
